module.exports = "/assets/data/562f252a1ba3fcc34a6d89cc339fabee-LS2.data.json";